import axios from 'axios';
import oboe from 'oboe';

const NODE_ENV = process.env.VUE_APP_NODE_ENV;

let API_URL;
if (NODE_ENV == 'prod') {
  API_URL = 'https://konselior-messages.prod.cloud.zipper.solutions';
} else if (NODE_ENV == 'stage') {
  API_URL = 'https://konselior-messages.dev.cloud.zipper.solutions';
} else {
  API_URL = 'http://localhost:8080';
}

export class APIService {
  constructor() {
  }

  getCustomer(userId) {
    const encodedUserId = btoa(userId);
    const url = `${API_URL}/seller/customer/${encodedUserId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getAllResumedBysellerId(customerId, sellerId) {
    const encodedSellerId = btoa(sellerId);
    const url = `${API_URL}/person/findAll/${customerId}/${encodedSellerId}`;

    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getResumedCustomerPaginated(userId, sellerId, page) {
    const encodedSellerId = btoa(sellerId);
    const url = `${API_URL}/person/getByCustomerIdAndSellerIdPaginated?customerId=${userId}&sellerId=${encodedSellerId}&page=${page}&size=100&projection=forAgenda`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getResumedCustomerAssignedPaginated(userId, seller, page) {
    const url = `${API_URL}/person/getByCustomerIdAndAssignedSellerPaginated?customerId=${userId}&seller=${seller}&page=${page}&size=100&projection=forAgenda`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getResumedCustomer(userId, seller) {
    const url = `${API_URL}/api/people/search/getByCustomerIdAndSeller?customerId=${userId}&seller=${seller}&projection=forManage`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getResumedCustomerAssigned(userId, seller) {
    const url = `${API_URL}/api/people/search/getByCustomerIdAndAssignedSeller?customerId=${userId}&seller=${seller}&projection=forManage`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getContact(personId) {
    const url = `${API_URL}/api/people/${personId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  async createIfPhoneNotExists(person) {
    const url = `${API_URL}/person/createIfPhoneNotExists`;
    return axios.post(url, person, { crossDomain: true });
  }

  updateStatus(personId, status) {
    const url = `${API_URL}/person/${personId}/block/${status}`;
    return axios.put(url, { crossDomain: true }).then(response => response);
  }

  updatePerson(person) {
    const url = `${API_URL}/person/`;
    return axios.put(url, person).then(response => response.data);
  }

  deletePerson(lead) {
    const url = `${API_URL}/person/lead`;
    return axios.delete(url, { data: lead }).then(response => response.data);
  }

  async patchPerson(person, field) {
    const url = `${API_URL}/person/`;
    const dbPerson = await this.getContact(person.id);
    dbPerson[field] = person[field];
    return axios.put(url, dbPerson).then(response => response);
  }

  async transferSeller(people, sellerId) {
    const encodedSellerId = btoa(sellerId)
    const url = `${API_URL}/person/transfer/to/${encodedSellerId}`;
    return axios.put(url, people).then(response => response.data);
  }

  async blockPeople(people) {
    const url = `${API_URL}/person/blockPeople`;
    return axios.put(url, people).then(response => response.data);
  }

  getCampaign(id) {
    const url = `${API_URL}/campaign/${id}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getCampaignByCustomer(customerId) {
    const url = `${API_URL}/campaign/byCustomer/${customerId}/stats`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getCampaignByCustomerPaginated(customerId, page) {
    const url = `${API_URL}/campaign/customer/${customerId}/stats?page=${page}&size=10`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getCampaignsForSeller(userId) {
    const encodedUserId = btoa(userId);
    const url = `${API_URL}/campaign/seller/${encodedUserId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getCampaignMessagesForSeller(campaignId, sellerId) {
    const encodedUserId = btoa(sellerId);
    const url = `${API_URL}/campaign/${campaignId}/seller/${encodedUserId}`;

    return oboe(url);
    // axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  async getCampaignStatsForSeller(campaignId, sellerId) {
    const encodedUserId = btoa(sellerId);
    const url = `${API_URL}/campaign/${campaignId}/seller/${encodedUserId}/stats`;
    const res = await axios.get(url, { crossDomain: true });
    return res.data;
  }

  async sendMessage(campaignId, campaignResultId, forceMobile = false) {
    const url = `${API_URL}/campaign/${campaignId}/send/${campaignResultId}?forceMobile=${forceMobile}`;
    try {
      const res = await axios.post(url, {}, { crossDomain: true });
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  skipMessage(campaignId, campaignResultId) {
    const url = `${API_URL}/campaign/${campaignId}/skip/${campaignResultId}`;
    return axios.post(url, {}, { crossDomain: true }).then(response => response.data);
  }

  getCampaignResult(leadCustomerId) {
    const url = `${API_URL}/api/campaignResults/search/sentByLeadCustomer?id=${leadCustomerId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  leadCustomer(customerId, area, phone) {
    const url = `${API_URL}/api/leadCustomers/search/byPhone?customerId=${customerId}&phoneArea=${area}&phone=${phone}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getSalesHistory(customerId, personIdERP) {
    const url = `${API_URL}/order/customer/${customerId}/?personIdERP=${personIdERP}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getTaskByCustomerIdAndSeller(customerId, seller) {
    const url = `${API_URL}/task/customer/${customerId}/seller/${seller}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  postTask(task) {
    const url = `${API_URL}/task`;
    return axios.post(url, task, { crossDomain: true }).then(response => response.data);
  }

  postCampaignRating(rating) {
    const url = `${API_URL}/campaign/rating`;
    return axios.post(url, rating, { crossDomain: true }).then(response => response.data);
  }

  async updateTask(task) {
    const url = `${API_URL}/task/${task.id}`;
    const res = await axios.put(url, task, { crossDomain: true });
    return res.data;
  }

  deleteTask(task) {
    const url = `${API_URL}/api/tasks/${task.id}`;
    return axios.delete(url, { crossDomain: true });
  }

  getVouchersByPhoneAreaAndPhoneAndCustomerId(phoneArea, phone, customerId) {
    const url = `${API_URL}/voucher/phoneArea/${phoneArea}/phone/${phone}/customer/${customerId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getVoucherById(id) {
    const url = `${API_URL}/voucher/${id}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  saveVoucherPhone(voucher) {
    const url = `${API_URL}/voucher/voucherPhone`;
    return axios.post(url, voucher, { crossDomain: true }).then(response => response.data);
  }

  getCustomerBySellerId(id) {
    const url = `${API_URL}/customer/seller/${id}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  async getProductsByCustomerIdAndStoreIdAndTemplateCatalogueId(customerId, storeId, templateCatalogueId, search, page, size, sortAsc = false) {
    const encodedStoreId = btoa(storeId);
    let url = `${API_URL}/product/customerId/${customerId}/store/${encodedStoreId}/templateCatalogueId/${templateCatalogueId}?page=${page}&size=${size}&sortAsc=${sortAsc}`;
    if (search) url += `&query=${search}`;
    const res = await axios.get(url, { crossDomain: true });
    return res.data;
  }

  async getProductByCustomerAndProductId(customerId, storeId, productId) {
    const encodedStoreId = btoa(storeId);
    const url = `${API_URL}/product/${productId}/customerId/${customerId}/store/${encodedStoreId}`;
    const res = await axios.get(url, { crossDomain: true });
    return res.data;
  }

  async getProductFiltersByCustomerId(customerId) {
    const url = `${API_URL}/product/customerId/${customerId}/filters`;
    const res = await axios.get(url, { crossDomain: true });
    return res.data;
  }

  async createCatalogue(catalogue) {
    const url = `${API_URL}/catalogue`;
    const res = await axios.post(url, catalogue, { crossDomain: true });
    return res.data;
  }

  async setProductMainImage(product, mainImage, customerId) {
    const url = `${API_URL}/product/metadata`;
    const res = await axios.post(url, {
      idERP: product.idERP,
      customerId: customerId || product.customerId,
      mainImage,
    }, { crossDomain: true });

    return res.data;
  }
}